export default __webpack_public_path__ + "static/media/github.3a8a3035.svg";